import { render, staticRenderFns } from "./Doki.vue?vue&type=template&id=079bc4b4&"
import script from "./Doki.vue?vue&type=script&lang=js&"
export * from "./Doki.vue?vue&type=script&lang=js&"
import style0 from "./Doki.vue?vue&type=style&index=0&id=079bc4b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports